import React from 'react';
import PropTypes from 'prop-types';

import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Row,
    Col
} from 'reactstrap';
import {
    TablePagination,
    PagingButton
} from 'components/elements';

import {
    UserHeader,
    UserTable,
    UserSearchBox
} from 'components/blocks';


const User = ({
    title,
    accountType,
    users,
    dispatcher,
    pageItemsAction,
    tablePagingAction,
    rolePagingAction,
    onFiltered,
    filteredUser,
    history
}) => {

    let userTable = users;
    if (filteredUser) {
        userTable = {
            ...filteredUser,
            pagination: users.pagination
        }
    }

    return (
        <Card style={{ backgroundColor: "#f7f7f7" }}>
            <CardHeader className="bg-dark">
                <UserHeader title={title} accountType={accountType} history={history} />
            </CardHeader>
            <CardBody style={{ paddingBottom: "0px" }}>
                <UserSearchBox
                    user={users}
                    dispatch={dispatcher}
                    action={rolePagingAction}
                    onFiltered={onFiltered}
                />
            </CardBody>
            <CardBody style={{ paddingTop: "0px" }}>
                <UserTable users={userTable} role={accountType.toLowerCase()} history={history} />
            </CardBody>
            <CardFooter>
                <Row>
                    <Col xs="12" sm="2" className="text-center text-sm-left mt-2 mt-sm-0 order-2 order-sm-1">
                        <PagingButton
                            numberOfRows={users.pagination.itemPerPage}
                            dispatch={dispatcher}
                            action={pageItemsAction}
                        />
                    </Col>
                    <Col xs="12" sm="10" className="text-center text-sm-right order-1 order-sm-2">
                        <div style={{ display: 'inline-block' }}>
                            <TablePagination
                                pagination={users.pagination}
                                sheetsPerPage={5}
                                dispatcher={dispatcher}
                                action={tablePagingAction}
                            />
                        </div>
                    </Col>
                </Row>
                <div className="text-right">
                    <small className="text-center text-sm-right text-muted">{users.pagination.total} Records Found</small>
                </div>
            </CardFooter>
        </Card>
    )
};

User.propTypes = {
    title: PropTypes.string,
    accountType: PropTypes.string,
    users: PropTypes.object,
    dispatcher: PropTypes.func,
    pageItemsAction: PropTypes.func,
    tablePagingAction: PropTypes.func,
    rolePagingAction: PropTypes.func,
    onFiltered: PropTypes.func,
    filteredUser: PropTypes.object,
    history: PropTypes.object
};

export default User;



// WEBPACK FOOTER //
// ./src/components/sections/User/User.js